import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';
import { BackendResponse } from '../../types';

export interface UserNotification {
  id: number;
  userId: number;
  module?: string | null;
  notificationType: string;
  titleText: string;
  bodyText?: string | null;
  bodyHtml?: string | null;
  linkUrl?: string | null;
  requestNo?: string | null;
  aggregateKey?: string | null;
  aggregateCount?: number;
  payload?: Record<string, any> | null;
  isRead: boolean;
  readAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

type NotificationPage = {
  list: UserNotification[];
  count: number;
  page: number;
  pageSize: number;
};

export interface SendPushNotificationPayload {
  userIds: number[];
  title?: string;
  message: string;
}

interface SendPushNotificationResult {
  deviceCount: number;
  userCount: number;
}

export const notificationApi = createApi({
  reducerPath: 'notification',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Notifications'],
  endpoints: builder => ({
    getMyNotifications: builder.query<
      BackendResponse<NotificationPage>,
      { page?: number; pageSize?: number }
    >({
      query: ({ page = 1, pageSize = 20 } = {}) => ({
        url: '/notifications/my',
        method: 'GET',
        params: { page, pageSize },
      }),
      providesTags: ['Notifications'],
    }),
    markNotificationRead: builder.mutation<BackendResponse<any>, number>({
      query: id => ({
        url: `/notifications/${id}/read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Notifications'],
    }),
    markNotificationAllRead: builder.mutation<BackendResponse<any>, void>({
      query: () => ({
        url: `/notifications/all-read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Notifications'],
    }),
    sendPushNotification: builder.mutation<
      BackendResponse<SendPushNotificationResult>,
      SendPushNotificationPayload
    >({
      query: body => ({
        url: '/push-notifications/send-to-users',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetMyNotificationsQuery,
  useMarkNotificationReadMutation,
  useMarkNotificationAllReadMutation,
  useSendPushNotificationMutation,
} = notificationApi;
